import React from 'react';
import { Download } from 'lucide-react';

interface DownloadSectionProps {
  isDownloading: boolean;
  onDownload: () => void;
}

export const DownloadSection: React.FC<DownloadSectionProps> = ({
  isDownloading,
  onDownload,
}) => {
  return (
    <div className="ca-card p-4 space-y-4">
      <div>
        <h3 className="text-base font-semibold text-slate-900 mb-2">Next steps</h3>
        <p className="text-sm text-slate-600">
          Download your enhanced CSV or email a copy to teammates.
        </p>
      </div>
      <div className="space-y-2">
        <button
          onClick={onDownload}
          disabled={isDownloading}
          className="w-full inline-flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white py-2.5 rounded-md text-sm font-medium transition-colors disabled:opacity-60"
        >
          <Download className="w-4 h-4" />
          {isDownloading ? 'Preparing...' : 'Download CSV'}
        </button>
        {/* Temporarily hidden - Email Results feature
        <button
          onClick={handleEmailResults}
          disabled={emailSent || !resolved?.email}
          className="w-full inline-flex items-center justify-center gap-2 border border-slate-200 hover:bg-slate-50 text-slate-700 py-2.5 rounded-md text-sm font-medium transition-colors disabled:opacity-60"
        >
          {emailSent ? (
            <>
              <CheckCircle className="w-4 h-4 text-green-600" />
              Email sent {resolved?.email ? `to ${resolved.email}` : ''}
            </>
          ) : (
            <>
              <Mail className="w-4 h-4" />
              Email results
            </>
          )}
        </button>
        */}
      </div>
      <p className="text-xs text-slate-500">
        This download link expires in 7 days. Sign in to access your batch history and re-download
        results for up to 90 days.
      </p>
    </div>
  );
};
